<div id="CreateToken">

  <!-- <app-navbar-new class="absolute top-0"></app-navbar-new> -->
  <div
    class="flex flex-col container inset-x-0 mx-auto w-full justify-center items-center flex-1 space-y-8">
    <div class="card m-auto w-full  xl:w-10/12 relative">
      <div class="card--info">
        <h2
          class="flex font-semibold text-sm md:text-base lg:text-lg mi--font-regular lg:!leading-[1.35] pb-2">
          <span class="text__yg--gradient flex">Create Your Token</span></h2>
        <p class="text-[#D9D9D9] text-sm lg:text-base ep--font-light lg:!leading-[1.75] lg:tracking-wide">You can name
          your token and choose features you want.</p>
      </div>
      <hr class="border--b">
      <form novalidate="" [formGroup]="createTokenForm" (ngSubmit)="createTokenFormSubmit()">
        <div class="grid grid-cols-12 gap-4 gap-y-6 sm:gap-6 lg:gap-8">
          <div class="col-span-12 md:col-span-6 relative">
            <div class="flex-between">
              <label for="name" class="input--label mb-2">Token Type* </label>
              <label for="name" class="block text-sm 2xl:text-md font
                                -regular text-secondary mb-2">Fee
                <span *ngIf="selectTokenType === 0" class="font-semibold text-sm text-white">{{ standardFeeToDisplay }}
                  {{currentNativeCurrency}}</span>
                <span *ngIf="selectTokenType === 1" class="font-semibold text-sm text-white">{{ liquidityFeeToDisplay }}
                  {{currentNativeCurrency}}</span>
              </label>
            </div>
            <div>
              <div class="w-full bg-[#21222C] rounded-xl rounded-t-xl relative">
                <button (clickOutside)="close('token')" (click)="this.isTokenTypeExpanded = !this.isTokenTypeExpanded"
                  class="btn__select" type="button">
                  <span class="btn__select-label">
                    <span *ngIf="selectTokenType === 0">Standard Token</span>
                    <span *ngIf="selectTokenType === 1">Liquidity Generator Token </span>
                  </span>
                  <img src="assets/icons/chevron-down-light.svg" class="w-5 h-5" alt="bx-finance">
                </button>
                <div
                  [ngClass]="{'hidden': !isTokenTypeExpanded, 'block border-[3px] border-solid border-[#4E1FA3]': isTokenTypeExpanded}"
                  class="z-10 mt-2 w-full text-base text-white lg:text-lg outline-[#4E1FA3] bg-[#21222C] rounded-xl absolute">
                  <ul class="list-none" aria-labelledby="dropdownButton" appDropdown>
                    <li (click)="onSelectTokenType(0)"
                      [ngClass]="selectTokenType === 0 ?'bg-[#4E1FA3] rounded-t-lg ':''"
                      class="py-4 px-5 flex justify-between cursor-pointer">
                      <a class="btn__select-menu">Standard Token</a>
                      <img *ngIf="selectTokenType === 0 " src="assets/icons/check-circle-light.svg" class="w-4 h-4"
                        alt="bx-finance">
                    </li>
                    <li (click)="onSelectTokenType(1)" class="py-4 px-5 flex justify-between cursor-pointer"
                      [ngClass]="selectTokenType === 1 ?'bg-[#4E1FA3] rounded-b-xl':''">
                      <a class="btn__select-menu">Liquidity Generator Token</a>
                      <img *ngIf="selectTokenType === 1 " src="assets/icons/check-circle-light.svg" class="w-4 h-4"
                        alt="bx-finance">
                    </li>
                  </ul>
                </div>
              </div>
              <div class="input--error" *ngIf="(f.token_type.touched || submitted) && f.token_type.errors?.required">
                This field is required *
              </div>
            </div>
          </div>
          <div class="col-span-12 md:col-span-6 relative">
            <label for="name" class="input--label mb-2">Name*</label>
            <input type="text" formControlName="token_name" name="tokenName" id="tokenName" placeholder="Ex. Shiba Inu"
              class="input--field" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode != 34 && event.charCode != 39))">
            <div class="input--error" *ngIf="(f.token_name.touched || submitted) && f.token_name.errors?.required">
              This field is required *
            </div>
          </div>
          <div class="col-span-12 md:col-span-6 relative">
            <label for="symbol" class="input--label mb-2">Symbol*</label>
            <input type="text" formControlName="token_symbol" name="tokenSymbol" id="tokenSymbol" placeholder="Ex. SHIB"
              class="input--field" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode != 34 && event.charCode != 39))">
            <div class="input--error" *ngIf="(f.token_symbol.touched || submitted) && f.token_symbol.errors?.required">
              This field is required *
            </div>
          </div>
          <div class="col-span-12 md:col-span-6 relative">
            <label for="decimal" class="block input--label mb-2">Decimal*</label>
            <div class="w-full bg-[#21222C] rounded-xl rounded-t-xl relative">
              <button (click)="onSelectDecimal()" (clickOutside)="close('decimal')" class="btn__select" type="button">
                <span class="btn__select-label"> {{selectDecimalLabel}}</span>
                <img src="assets/icons/chevron-down-light.svg" class="w-4 h-4 lg:w-5 lg:h-5" alt="bx-finance">
              </button>
              <div
                [ngClass]="{'hidden': !isDecimalExpanded, 'block border-[3px] border-solid border-[#4E1FA3]': isDecimalExpanded}"
                class="z-10 mt-2 w-full text-base text-white lg:text-lg outline-[#4E1FA3] bg-[#21222C] rounded-xl absolute">
                <ul class="list-none" aria-labelledby="dropdownButton">
                  <li (click)="onSelectDecimal('6')"
                    [ngClass]="selectDecimalLabel === '6'?'bg-[#4E1FA3] rounded-t-lg ':''"
                    class="py-4 px-5 flex justify-between cursor-pointer">
                    <a class="btn__select-menu">6</a>
                    <img *ngIf="selectDecimalLabel === '6' " src="assets/icons/check-circle-light.svg" class="w-5 h-5"
                      alt="bx-finance">
                  </li>
                  <li (click)="onSelectDecimal('9')" class="py-4 px-5 flex justify-between cursor-pointer"
                    [ngClass]="selectDecimalLabel === '9'?'bg-[#4E1FA3]':''">
                    <a class="btn__select-menu">9</a>
                    <img *ngIf="selectDecimalLabel === '9' " src="assets/icons/check-circle-light.svg" class="w-5 h-5"
                      alt="bx-finance">
                  </li>
                  <li (click)="onSelectDecimal('18')" class="py-4 px-5 flex justify-between cursor-pointer"
                    [ngClass]="selectDecimalLabel === '18'?'bg-[#4E1FA3] rounded-b-xl':''">
                    <a class="btn__select-menu">18</a>
                    <img *ngIf="selectDecimalLabel === '18' " src="assets/icons/check-circle-light.svg" class="w-5 h-5"
                      alt="bx-finance">
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-span-12 md:col-span-6 relative">
            <label for="token-supply" class="input--label mb-2"> Token Supply*</label>
            <input name="totalSupply" formControlName="total_supply" [allowNegativeNumbers]="false" mask="0*.0000"
              maxlength="16" placeholder="Token Supply" class="input--field" type="text" value="">
            <div class="input--error" *ngIf="(f.total_supply.touched || submitted) && f.total_supply.errors?.required">
              This field is required *
            </div>
            <!-- <div class="input--error" *ngIf="(f.total_supply.touched || submitted) && f.total_supply.errors?.min">
                                Total Supply is Invalid
                            </div> -->
            <div class="input--error"
              *ngIf="(f.total_supply.touched || submitted)  && f.total_supply.errors?.maxLength">
              Invalid Token Supply
            </div>
          </div>
          <!-- TODO | BEGIN: Liquidity Generator Menu Input Fields -->
          <div *ngIf="selectTokenType === 1" class="col-span-12 md:col-span-6 relative">
            <label for="router" class="input--label mb-2">Router*</label>
            <div class="w-full bg-secondary-light rounded-xl relative ">
              <button (click)="onSelectRouter()" (clickOutside)="close('router')" class="btn__select" type="button">
                <span class="btn__select-label" *ngIf="!selectRouterName">
                  Select Router
                </span>
                <span class="btn__select-label" *ngIf="selectRouterName">
                  {{selectRouterName}}
                </span>
                <img src="assets/icons/chevron-down-light.svg" class="w-5 h-5" alt="bx-finance">
              </button>
              <div ngDefaultControl formControlName="router"
                [ngClass]="{'hidden': !isRouterExpanded, 'block border-[3px] border-solid border-primary': isRouterExpanded}"
                class="z-10 mt-2 w-full text-base text-white lg:text-lg outline-primary bg-secondary-dark rounded-xl absolute">
                <ul class="list-none" aria-labelledby="dropdownButton">
                  <li *ngIf="this.account.chainId == '0x61' || this.account.chainId == '0x38'" (click)="onSelectRouter('Pancake Swap', 'PANCAKE_SWAP')"
                    [ngClass]="selectRouterName === 'Pancake Swap'?'bg-primary rounded-xl ':''"
                    class="py-4 px-5 flex justify-between cursor-pointer">
                    <a class="btn__select-menu">Pancake Swap</a>
                    <img *ngIf="selectRouterName === 'Pancake Swap' " src="assets/icons/check-circle-light.svg"
                      class="w-4 h-4" alt="bx-finance">
                  </li>
                  <li *ngIf="this.account.chainId == '0x61' || this.account.chainId == '0x38'" (click)="onSelectRouter('Sushi Swap', 'SUSHI_SWAP')"
                    [ngClass]="selectRouterName === 'Sushi Swap'?'bg-primary rounded-xl ':''"
                    class="py-4 px-5 flex justify-between cursor-pointer">
                    <a class="btn__select-menu">Sushi Swap</a>
                    <img *ngIf="selectRouterName === 'Sushi Swap' " src="assets/icons/check-circle-light.svg"
                      class="w-4 h-4" alt="bx-finance">
                  </li>
                  <li *ngIf="this.account.chainId == '0x152' || this.account.chainId == '0x19'" (click)="onSelectRouter('Photon Swap', 'PHOTON_SWAP')"
                    [ngClass]="selectRouterName === 'Photon Swap'?'bg-primary rounded-xl ':''"
                    class="py-4 px-5 flex justify-between cursor-pointer">
                    <a class="btn__select-menu">Photon Swap</a>
                    <img *ngIf="selectRouterName === 'Photon Swap' " src="assets/icons/check-circle-light.svg"
                      class="w-4 h-4" alt="bx-finance">
                  </li>
                  <li *ngIf="this.account.chainId == '0x13881' || this.account.chainId == '0x89'" (click)="onSelectRouter('Quick Swap', 'QUICK_SWAP')"
                    [ngClass]="selectRouterName === 'Quick Swap'?'bg-primary rounded-xl ':''"
                    class="py-4 px-5 flex justify-between cursor-pointer">
                    <a class="btn__select-menu">Quick Swap</a>
                    <img *ngIf="selectRouterName === 'Quick Swap' " src="assets/icons/check-circle-light.svg"
                      class="w-4 h-4" alt="bx-finance">
                  </li>
                  <li *ngIf="this.account.chainId == '0x13881' || this.account.chainId == '0x89'" (click)="onSelectRouter('Sushi Swap', 'SUSHI_SWAP')"
                    [ngClass]="selectRouterName === 'Sushi Swap'?'bg-primary rounded-xl ':''"
                    class="py-4 px-5 flex justify-between cursor-pointer">
                    <a class="btn__select-menu">Sushi Swap</a>
                    <img *ngIf="selectRouterName === 'Sushi Swap' " src="assets/icons/check-circle-light.svg"
                      class="w-4 h-4" alt="bx-finance">
                  </li>
                  <li *ngIf="this.account.chainId == '0xfa2' || this.account.chainId == '0xfa'" (click)="onSelectRouter('Spooky Swap', 'SPOOKY_SWAP')"
                    [ngClass]="selectRouterName === 'Spooky Swap'?'bg-primary rounded-xl ':''"
                    class="py-4 px-5 flex justify-between cursor-pointer">
                    <a class="btn__select-menu">Spooky Swap</a>
                    <img *ngIf="selectRouterName === 'Spooky Swap' " src="assets/icons/check-circle-light.svg"
                      class="w-4 h-4" alt="bx-finance">
                  </li>
                  <li *ngIf="this.account.chainId == '0x5' || this.account.chainId == '0x1'" (click)="onSelectRouter('Uni Swap', 'UNI_SWAP')"
                    [ngClass]="selectRouterName === 'Uni Swap'?'bg-primary rounded-xl ':''"
                    class="py-4 px-5 flex justify-between cursor-pointer">
                    <a class="btn__select-menu">Uni Swap</a>
                    <img *ngIf="selectRouterName === 'Uni Swap' " src="assets/icons/check-circle-light.svg"
                      class="w-4 h-4" alt="bx-finance">
                  </li>
                  <li *ngIf="this.account.chainId == '0x5' || this.account.chainId == '0x1'" (click)="onSelectRouter('Sushi Swap', 'SUSHI_SWAP')"
                    [ngClass]="selectRouterName === 'Sushi Swap'?'bg-primary rounded-xl ':''"
                    class="py-4 px-5 flex justify-between cursor-pointer">
                    <a class="btn__select-menu">Sushi Swap</a>
                    <img *ngIf="selectRouterName === 'Sushi Swap' " src="assets/icons/check-circle-light.svg"
                      class="w-4 h-4" alt="bx-finance">
                  </li>
                  <!-- <li *ngIf="this.account.chainId == '0xa869'" (click)="onSelectRouter('Pangolin Swap', 'PANGOLIN_SWAP')" [ngClass]="selectRouterName === 'Pangolin Swap'?'bg-primary rounded-xl ':''" class="py-4 px-5 flex justify-between cursor-pointer">
                                            <a class="btn__select-menu">Pangolin Swap</a>
                                            <img *ngIf="selectRouterName === 'Pangolin Swap' " src="assets/icons/check-circle-light.svg" class="w-4 h-4" alt="bx-finance">
                                        </li> -->
                  <li *ngIf="this.account.chainId == '0xa869' || this.account.chainId == '0xa86a'" (click)="onSelectRouter('Sushi Swap', 'SUSHI_SWAP')"
                    [ngClass]="selectRouterName === 'Sushi Swap'?'bg-primary rounded-xl ':''"
                    class="py-4 px-5 flex justify-between cursor-pointer">
                    <a class="btn__select-menu">Sushi Swap</a>
                    <img *ngIf="selectRouterName === 'Sushi Swap' " src="assets/icons/check-circle-light.svg"
                      class="w-4 h-4" alt="bx-finance">
                  </li>
                  <li *ngIf="this.account.chainId == '0x507' || this.account.chainId == '0x504'" (click)="onSelectRouter('Solarbeam', 'SOLARBEAM')"
                    [ngClass]="selectRouterName === 'Solarbeam'?'bg-primary rounded-xl ':''"
                    class="py-4 px-5 flex justify-between cursor-pointer">
                    <a class="btn__select-menu">Solar Flare</a>
                    <img *ngIf="selectRouterName === 'Solarbeam' " src="assets/icons/check-circle-light.svg"
                      class="w-4 h-4" alt="bx-finance">
                  </li>
                </ul>
              </div>
            </div>
            <div class="input--error" *ngIf="(f.router.touched || submitted) && f.router.errors?.required">
              This field is required *
            </div>
          </div>
          <div *ngIf="selectTokenType === 1" class="col-span-12 md:col-span-6 relative">
            <label for="generate-yield" class="input--label mb-2"> Transaction Fee to Generate Yield (%)*</label>
            <input name="generate-yield" formControlName="reflectionFee" placeholder="Transaction Fee to Generate Yield"
              [allowNegativeNumbers]="false" mask="0*.0000" class="input--field" type="text" value="">
            <div class="input--error"
              *ngIf="(f.reflectionFee.touched || submitted) && f.reflectionFee.errors?.required">
              This field is required *
            </div>
            <div class="input--error" *ngIf="(f.reflectionFee.touched || submitted) && f.reflectionFee.errors?.min">
              Invalid Token Type
            </div>
          </div>
          <div *ngIf="selectTokenType === 1" class="col-span-12 md:col-span-6 relative">
            <label for="generate-liquidity" class="input--label mb-2"> Transaction Fee to Generate Liquidity
              (%)*</label>
            <input name="generate-liquidity" formControlName="liquidityFee"
              placeholder="Transaction Fee to Generate Liquidity" class="input--field" [allowNegativeNumbers]="false"
              mask="0*.0000" type="text" value="">
            <div class="input--error" *ngIf="(f.liquidityFee.touched || submitted) && f.liquidityFee.errors?.required">
              This field is required *
            </div>
            <div class="input--error" *ngIf="(f.liquidityFee.touched || submitted) && f.liquidityFee.errors?.min">
              Invalid Transaction Fee
            </div>
          </div>
          <div *ngIf="selectTokenType === 1" class="col-span-12 md:col-span-6 relative">
            <label for="charity-address" class="input--label mb-2"> Charity Address*</label>
            <input name="charity-address" formControlName="charityAddress" placeholder="Charity Address"
              class="input--field" type="text" value="">
            <div class="input--error"
              *ngIf="(f.charityAddress.touched || submitted) && f.charityAddress.errors?.required">
              This field is required *
            </div>
            <div class="input--error"
              *ngIf="(f.charityAddress.touched || submitted) && !f.charityAddress.errors?.required && isCharityAddressInValid">
              Invalid wallet address
            </div>
          </div>
          <div *ngIf="selectTokenType === 1" class="col-span-12 md:col-span-6 relative">
            <label for="charity-percent" class="input--label mb-2"> Charity Percent (%)*</label>
            <input name="charity-percent" formControlName="charityFee" placeholder="Charity Percent"
              class="input--field" [allowNegativeNumbers]="false" mask="0*.0000" type="text" value="">
            <div class="input--error" *ngIf="(f.charityFee.touched || submitted) && f.charityFee.errors?.required">
              This field is required *
            </div>
            <div class="input--error" *ngIf="(f.charityFee.touched || submitted) && f.charityFee.errors?.min">
              Invalid Charity Percent
            </div>
          </div>
          <div *ngIf="selectTokenType === 1" class="col-span-12 md:col-span-6 relative">
            <label for="marketing-address" class="input--label mb-2"> Marketing Address*</label>
            <input name="marketing-address" formControlName="marketingAddress" placeholder="Marketing Address"
              class="input--field" type="text" value="">
            <div class="input--error"
              *ngIf="(f.marketingAddress.touched || submitted) && f.marketingAddress.errors?.required">
              This field is required *
            </div>
            <div class="input--error"
              *ngIf="(f.marketingAddress.touched || submitted) && !f.marketingAddress.errors?.required && isMarketingAddressInValid">
              Invalid Marketing Address
            </div>
          </div>
          <div *ngIf="selectTokenType === 1" class="col-span-12 md:col-span-6 relative">
            <label for="marketing-percent" class="input--label mb-2"> Marketing Percent (%)*</label>
            <input name="marketing-percent" formControlName="marketingFee" placeholder="Marketing Percent"
              class="input--field" [allowNegativeNumbers]="false" mask="0*.0000" type="text" value="">
            <div class="input--error" *ngIf="(f.marketingFee.touched || submitted) && f.marketingFee.errors?.required">
              This field is required *
            </div>
            <div class="input--error" *ngIf="(f.marketingFee.touched || submitted) && f.marketingFee.errors?.min">
              Invalid Marketing Percent
            </div>
          </div>
          <div *ngIf="selectTokenType === 1" class="col-span-12 md:col-span-6 relative">
            <label for="liquidity-fee-to-sell" class="input--label mb-2">Liquidity Fee to Sell*</label>
            <input name="liquidity-fee-to-sell" formControlName="liquidityFeeToSell" placeholder="Liquidity Fee to Sell"
              class="input--field" [allowNegativeNumbers]="false" mask="0*.0000" type="text" value="">
            <div class="input--error"
              *ngIf="(f.liquidityFeeToSell.touched || submitted) && f.liquidityFeeToSell.errors?.required">
              This field is required *
            </div>
            <div class="input--error"
              *ngIf="(f.liquidityFeeToSell.touched || submitted) && f.liquidityFeeToSell.errors?.min">
              Invalid Liquidity Fee
            </div>
          </div>
          <div *ngIf="selectTokenType === 1" class="col-span-12 md:col-span-6 relative">
            <label for="marketing-fee-to-sell" class="input--label mb-2">Marketing Fee to Sell*</label>
            <input name="marketing-fee-to-sell" formControlName="marketingFeeToSell" placeholder="Marketing Fee to Sell"
              class="input--field" [allowNegativeNumbers]="false" mask="0*.0000" type="text" value="">
            <div class="input--error"
              *ngIf="(f.marketingFeeToSell.touched || submitted) && f.marketingFeeToSell.errors?.required">
              This field is required *
            </div>
            <div class="input--error"
              *ngIf="(f.marketingFeeToSell.touched || submitted) && f.marketingFeeToSell.errors?.min">
              Invalid Marketing Fee
            </div>
          </div>
          <div *ngIf="selectTokenType === 1" class="col-span-12 md:col-span-6 relative">
            <label for="charity-fee-to-sell" class="input--label mb-2">Charity Fee to Sell*</label>
            <input name="charity-fee-to-sll" formControlName="charityFeeToSell" placeholder="Charity Fee to Sell"
              class="input--field" [allowNegativeNumbers]="false" mask="0*.0000" type="text" value="">
            <div class="input--error"
              *ngIf="(f.charityFeeToSell.touched || submitted) && f.charityFeeToSell.errors?.required">
              This field is required *
            </div>
            <div class="input--error"
              *ngIf="(f.charityFeeToSell.touched || submitted) && f.charityFeeToSell.errors?.min">
              Invalid Charity Fee
            </div>
          </div>
          <div *ngIf="selectTokenType === 1" class="col-span-12 md:col-span-6 relative">
            <label for="transaction-limit" class="input--label mb-2"> Transaction Limit(%)*</label>
            <input name="transaction-limit" formControlName="transactionLimit" placeholder="Transaction Limit"
              class="input--field" [allowNegativeNumbers]="false" mask="0*.0000" type="text" value="">
            <div class="input--error"
              *ngIf="(f.transactionLimit.touched || submitted) && f.transactionLimit.errors?.required">
              This field is required *
            </div>
            <div class="input--error"
              *ngIf="(f.transactionLimit.touched || submitted) && f.transactionLimit.errors?.min">
              Invalid Transaction Limit
            </div>
          </div>
          <div class="col-span-12">
            <p *ngIf="selectTokenType === 1" class="font-semibold text-sm md:text-base 2xl:text-lg text-secondary">Note:
              Fee given as 0 will be considered as no fee. Transaction limit given as 100% will be considered as no
              limit</p>
          </div>

          <!-- TODO | END: Liquidity Generator Menu Input Fields -->
          <div class="col-span-12 md:col-span-6 my-auto">
              <button *ngIf="!isMetamaskConnected" (click)="connectWallet()"
                class="btn__primary bg-[#4E1FA3]/30 border border-solid border-[#4e1fa3] w-full mt-0 shadow-none" type="button">
                Connect Wallet
              </button>
            <button class="btn__primary bg-[#4E1FA3]/30 border border-solid border-[#4e1fa3] w-full mt-0 cursor-pointer shadow-none"
              *ngIf="!processing && isMetamaskConnected" type="submit">
              Create token
            </button>
            <button type="button" *ngIf="processing"
              class="btn__primary bg-[#4E1FA3]/30 border border-solid border-[#4e1fa3] w-full mt-0 cursor-not-allowed shadow-none"
              disabled="">
              <svg class="animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24">
                <circle class="opacity-0" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                </circle>
                <path class="opacity-75" fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                </path>
              </svg>
              Processing...
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
 </div>

<!-- BEGIN: TOKEN CREATED SUCCESSFULLY -->
<div class="fixed z-50 inset-0 overflow-y-auto" [ngClass]="isTokenCreated == true ? 'block' : 'hidden'"
  aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-center md:items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-[#0f172acc] backdrop-blur-md transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
    <div
      class="relative inline-block align-bottom bg-secondary-dark shadow-md p-6 rounded-xl text-left overflow-hidden transform transition-all sm:my-8 sm:align-middle sm:w-[34rem] md:w-[42rem] token-create-success">
      <div class="flex justify-between items-center">
        <div class="flex justify-between items-center">
          <img src="assets/icons/check-circle-success.svg" class="mr-2 w-5 h-5" alt="bx-finance" />
          <h2 class="font-bold text-success text-base lg:text-lg 2xl:text-xl">Token Created Successfully
          </h2>
        </div>
        <div (click)="this.isTokenCreated = false"
          class="bg-secondary-black cursor-pointer w-8 h-8 md:h-10 md:w-10 rounded-lg flex justify-center items-center">
          <img src="assets/icons/x-light.svg" class="m-auto w-4 h-4 md:w-5 md:h-5" alt="bx-finance" />
        </div>
      </div>
      <hr class="border-grey border-b-2 border-solid my-3" />
      <div class="grid grid-cols-12 gap-4 gap-y-6 sm:gap-6 lg:gap-8">
        <div class="col-span-12 md:col-span-4">
          <h6 class="text-primary-light font-semibold text-sm md:text-base 2xl:text-md">Name</h6>
          <p class="text-white font-bold text-md md:text-lg 2xl:text-xl">{{ this.tokenInfo.name }}</p>
        </div>
        <div class="col-span-12 md:col-span-4">
          <h6 class="text-primary-light font-semibold text-sm md:text-base 2xl:text-md">Symbol</h6>
          <p class="text-white font-bold text-md md:text-lg 2xl:text-xl">{{ this.tokenInfo.symbol }}</p>
        </div>
        <div class="col-span-12 md:col-span-4">
          <h6 class="text-primary-light font-semibold text-sm md:text-base 2xl:text-md">Total Supply</h6>
          <p class="text-white font-bold text-md md:text-lg 2xl:text-xl">{{ this.tokenInfo.totalSupply | number }}</p>
        </div>
        <div class="col-span-12">
          <h6 class="text-primary-light font-semibold text-sm md:text-base 2xl:text-md">Address</h6>
          <p class="text-white font-bold text-md md:text-lg 2xl:text-xl break-all">{{ this.createdTokenAddress }}</p>
        </div>
        <div *ngIf="this.selectTokenType == 1" class="col-span-12 md:col-span-4">
          <h6 class="text-primary-light font-semibold text-sm md:text-base 2xl:text-md">TaxFee Percent</h6>
          <p class="text-white font-bold text-md md:text-lg 2xl:text-xl">{{totalFee}}%</p>
        </div>
        <div *ngIf="this.selectTokenType == 1" class="col-span-12 md:col-span-4">
          <h6 class="text-primary-light font-semibold text-sm md:text-base 2xl:text-md">Liquidity Fee Percentage</h6>
          <p class="text-white font-bold text-md md:text-lg 2xl:text-xl">{{addLiquidityFee}}%</p>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4 md:gap-6 mt-4">
        <div class="col-span-12 md:col-span-4">
          <button (click)="openTXPage()" target="_blank"
            class="bg-transparent w-full border-primary-light border border-solid text-primary-light font-medium text-base 2xl:text-md py-3 px-4 rounded-lg">
            View Transaction
          </button>
        </div>
        <div class="col-span-12 md:col-span-4">
          <button (click)="copyAddress()" type="button"
            class="bg-secondary-light w-full border-secondary-light border border-solid text-white font-medium text-base 2xl:text-md py-3 px-4 rounded-lg">
            Copy Address
          </button>
        </div>
        <div class="col-span-12 md:col-span-4">
          <button tooltip="Coming Soon" type="button"
            class="btn__primary bg-[#4E1FA3]/30 border border-solid border-[#4e1fa3] w-full shadow-none text-white font-medium text-base 2xl:text-md py-3 px-4 rounded-lg">
            Create Launchpad
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- BEGIN: TOKEN CREATED SUCCESSFULLY -->

<app-waiting-popup></app-waiting-popup>
